/* eslint-disable */
<template>
    <div id="app" class="raiz">
        <div class="vis-header">
            <h4>Enrollment rate in secondary education</h4>
            <!--<p>Suma de la inversión pública y privada en infraestructura como porcentaje del PIB.</p>-->
        </div>

        <div class="field is-horizontal vis-controls">
            <div class="field-label is-normal">
                <label class="label">Country: </label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div class="select">
                            <select id="country-select" class="is-hovered" @change="loadCountryData" v-model="selectedCountry">
                                <option v-for="country in countries" v-bind:value="country">{{country}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="vis-body">
            <div class="vis-content">
                <vue-plotly :data="vis1.data" :layout="vis1.layout" :options="vis1.options"/>
            </div>
        </div>

        <div class="vis-footer">
            <p>
                <small>Source: CEPAL.</small>
            </p>
        </div>
    </div>
</template>

<script>

    import d3 from "./d3.import.js";
    import plotly from "./plotly.import";
    import plotES from 'plotly.js/lib/locales/es'
    import VuePlotly from '@statnett/vue-plotly';

    plotly.register(plotES);
    plotly.setPlotConfig({locale: 'en'});

    export default {
        name: 'app',
        components: {
            VuePlotly
        },
        data: () => {
            return {
                vis1: {
                    data: [],
                    layout: {
                        //title: 'Inversión como porcentaje del PIB',
                        showlegend: false,
                        margin: {
                            l: 50,
                            r: 20,
                            b: 30,
                            t: 30,
                            pad: 0
                        },
                        font: {
                            family: 'Open Sans, Helvetica, Arial, sans-serif',
                            size: 12,
                            color: '#3C3B3B'
                        },
                        xaxis: {
                            // fixedrange: true
                        },
                        yaxis: {
                            title: 'Enrollment rate (%)',
                            fixedrange: true,
                            range: [0, 2],
                            hoverformat: '.2f'
                        },
                        colorway: ['#34729F']
                    },
                    options: {},
                },
                matricula_data: undefined,
                countries: [],
                selectedCountry: undefined
            }
        },
        mounted: function () {
            this.loadData();
        },
        methods: {
            loadData: function () {
                let vm = this;
                d3.csv(process.env.BASE_URL + "data/matricula_secundaria_clean.csv").then(function (data) {
                    vm.matricula_data = data;
                    vm.loadSelectOptions(data);
                });
            },
            loadSelectOptions: function (data) {
                let vm = this;
                vm.countries.push("All countries");
                vm.countries.push("Central America");
                vm.countries.push(...new Set(data.map(x => x.pais_en)));

                vm.selectedCountry = "All countries";
                this.loadCountryData();
            },
            loadCountryData: function () {
                let vm = this;


                let paises_centroamerica = ["Guatemala", "Belice", "Honduras", "El Salvador", "Nicaragua", "Panamá"];
                let country_data = vm.matricula_data;
                if("All countries" === vm.selectedCountry) {

                } else if("Central America" === vm.selectedCountry) {
                    country_data = vm.matricula_data.filter(x => paises_centroamerica.includes(x.pais));
                } else {
                    country_data = vm.matricula_data.filter(x => x.pais === vm.selectedCountry);
                }
                let maxValue = d3.max(country_data.map(x => +x.matricula));

                let valuesBySector = d3.nest()
                    .key(function (d) {
                        return d.pais;
                    })
                    .entries(country_data)
                    .sort(function (a, b) {
                        return a.year - b.year;
                    });

                vm.vis1.layout.yaxis.range = [0, maxValue * 1.02];

                vm.vis1.data = valuesBySector.map(function (d) {
                    let x = [];
                    let y = [];
                    d.values.forEach(function (d) {
                        x.push(d.ano);
                        y.push(d.matricula);
                    });
                    return {
                        type: 'scatter',
                        x: x,
                        y: y,
                        name: d.key,
                        line: {
                            // color: "#CC503E",
                            shape: 'spline',
                            width: 3
                        }
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~bulma/bulma";
    @import 'assets/typography';

    #app {
        font-family: 'Open Sans', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #222;
        max-width: 720px;
        margin: 0 auto;
        padding: 15px 5px;

        border-top: 2px solid #3C3B3B;

        @include mobile {
            padding: 15px 10px;
        }
    }

    div.vis-header {
        h3, h4 {
            margin-top: 0;
        }

        p {

        }
    }

    div.vis-controls {
        margin-top: 20px;
    }

    div.vis-body {
        min-height: 100px;
        margin-top: 0;
    }

    div.vis-footer {
        margin-top: 10px;
        padding: 5px 0;
        border-top: 1px solid grey;

        p {
            margin-bottom: 0;
        }
    }
</style>
<style lang="scss">
    .modebar {
        display: none !important;
    }
</style>
